import { render } from "./ManagerCreateModal.vue?vue&type=template&id=3b5b6790&scoped=true"
import script from "./ManagerCreateModal.vue?vue&type=script&lang=js"
export * from "./ManagerCreateModal.vue?vue&type=script&lang=js"

import "./ManagerCreateModal.vue?vue&type=style&index=0&id=3b5b6790&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5b6790"]])

export default __exports__